<div *ngIf="formContent.formAttribute" class="form-constructor-section">
  <p
    *ngIf="formContent.formAttribute.titleId"
    class="form-title pt-2 pt-sm-4"
    attr.data-test-id="title-{{ formContent.formAttribute.dataTestId }}"
    [id]="'title-' + formContent.formAttribute.dataTestId"
  >
    {{ formContent.formAttribute.titleId | translate }}
  </p>
  <app-form-constructor-base [dataStrategy]="dataStrategy" [formContent]="formContent"></app-form-constructor-base>
</div>
